<template>
    <status-autocomplete
        ref="status"
        :v="$v"
        name="selectedStatusId"
        v-model="$v.selectedStatusId.$model"
        length-type="w--xl"
    />
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import StatusAutocomplete from '@/components/Autocomplete/StatusAutocomplete';

export default {
    name:        'StatusContainer',
    components:  {StatusAutocomplete},
    props:       {
        lengthType: {
            type:     String,
            required: false,
            default:  () => null
        }
    },
    data() {
        return {
            selectedStatusId: null,
        }
    },
    computed:    {
        statusId() {
            return this.$store.getters['projects/project/units/unit/statusId'];
        }
    },
    mounted() {
        this.$refs.status.setSelectedId(this.statusId);
    },
    watch:       {
        selectedStatusId: function (nextValue, prevValue) {
            if (nextValue !== prevValue && null !== prevValue && null !== nextValue) {
                this.save();
            }
        },
    },
    validations: {
        selectedStatusId: {
            required,
        },
    },
    methods:     {
        save() {
            this.$store.dispatch('projects/project/units/unit/updateUnit', {statusId: this.selectedStatusId})
                .then(() => this.$dmv.notifySuccess('Upraveno'))
                .catch((message) => this.$dmv.notifyError(message));
        }
    }
}
</script>
